import React, { Component } from "react";
import AppBar from "material-ui/AppBar";
import logo from "../../common/assets/logo-wide-whiteBO.png";

class Header extends Component {
	render() {
		const styles = {
			title: {
				//marginLeft: this.props.hideDrawer ? 250 : 0
				padding: 3,
				height: 30
			},
			titleIMG: {
				marginRight: 10,
				padding: 3,
				height: 30,
				marginTop: "-4px"
			},
			appBar: {
				position: "fixed",
				//top: 0,
				backgroundColor: "#2d5986",
				padding: 5
			}
		};

		return (
			<AppBar
				style={styles.appBar}
				onLeftIconButtonTouchTap={this.props.leftIconClick}
				iconStyleLeft={{
					display: this.props.login ? "block" : "none"
				}}
				titleStyle={styles.title}
				title={"Sistema de Administración Sindical"}
				iconElementRight={
					<img
						src={logo}
						className="App-logo"
						alt="caster"
						style={{
							//width: "150px",
							height: "37px"
						}}
					/>
				}
				iconStyleRight={styles.titleIMG}
			/>
		);
	}
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js